import { render, staticRenderFns } from "./LaboratoryTags.vue?vue&type=template&id=dc5b0748&scoped=true"
import script from "./LaboratoryTags.vue?vue&type=script&lang=js"
export * from "./LaboratoryTags.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryTags.vue?vue&type=style&index=0&id=dc5b0748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5b0748",
  null
  
)

export default component.exports